module.exports = __webpack_public_path__ + "img/logo.c651f2d8.png";